// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__50AVS","box":"style_box__5ix3O","active":"style_active__lCU0m","title":"style_title__3VJ8J","item":"style_item__axwci"};